import { render, staticRenderFns } from "./probationModals.vue?vue&type=template&id=3b6e2fe1&scoped=true"
import script from "./probationModals.vue?vue&type=script&lang=js"
export * from "./probationModals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6e2fe1",
  null
  
)

export default component.exports